import "./GalleryInviteSection.scss";
import { useNavigate } from "react-router-dom";
import imgFloor1Wide from "images/Gallery/PierwszePietro/33.webp";
import imgFloor1Dumbbells from "images/Gallery/PierwszePietro/23.webp";
import imgFloor2Machines from "images/Gallery/DrugiePietro/4.webp";
import CommonButton from "pages/Components/CommonButton/CommonButton";
import VectorUnderline from "pages/Components/VectorUnderline/VectorUnderline";
import Vector from "images/GrayVectorTop.svg";

const GalleryInviteSection = () => {
  const navigate = useNavigate();

  return (
    <>
      <img
        src={Vector}
        alt="Centrum sily top vector"
        className="galleryInviteTopVector"
        width={"100%"}
      />
      <section className="galleryInvite">
        <div className="galleryInviteInner">
          <div className="galleryInviteText">
            <div className="galleryInviteEyebrow">Centrum Siły</div>
            <h2 className="galleryInviteTitle">
              Odkryj wnętrze
              <span className="galleryInviteRed"> siłowni</span>
            </h2>
            <VectorUnderline />
            <p className="galleryInviteDesc">
              Dwa piętra profesjonalnego sprzętu — strefa wolnych ciężarów,
              nowoczesne maszyny siłowe, urządzenia cardio oraz komfortowe
              szatnie. Przekonaj się, co czeka na Ciebie w Centrum Siły.
            </p>
            <ul className="galleryInviteFeatures">
              <li>
                <span className="galleryFeatureDot" />
                Strefa wolnych ciężarów i hantli
              </li>
              <li>
                <span className="galleryFeatureDot" />
                Maszyny siłowe na obu piętrach
              </li>
              <li>
                <span className="galleryFeatureDot" />
                Strefa cardio i rozciągania
              </li>
              <li>
                <span className="galleryFeatureDot" />
                Szatnie z prysznicami i szafkami
              </li>
            </ul>
            <CommonButton
              text="Zobacz galerię"
              marginTop="36px"
              onClick={() => navigate("/gallery")}
              blackVariant
            />
          </div>

          <div className="galleryInviteCollage">
            <div className="galleryCollageMain">
              <img
                src={imgFloor1Wide}
                alt="Pierwsze piętro siłowni Centrum Siły"
                className="galleryCollageImg"
                loading="lazy"
              />
              <div className="galleryCollageLabel">Wolne Ciężary</div>
            </div>

            <div className="galleryCollageGrid">
              <div className="galleryCollageItem">
                <img
                  src={imgFloor2Machines}
                  alt="Strefa maszyn — drugie piętro"
                  className="galleryCollageImg"
                  loading="lazy"
                />
                <div className="galleryCollageLabel">Strefa Maszyn</div>
              </div>
              <div className="galleryCollageItem">
                <img
                  src={imgFloor1Dumbbells}
                  alt="Strefa wolnych ciężarów"
                  className="galleryCollageImg"
                  loading="lazy"
                />
                <div className="galleryCollageLabel">Wolne Ciężary</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GalleryInviteSection;
